/* Medicus search autocomplete.

   Desktop: turns the existing .search-mega-menu bar into a live autocomplete.
            The browse mega menu stays as the empty state.
   Mobile:  the magnifier opens a full-screen search overlay using the same
            renderer, instead of the stock theme modal (which only returned
            products and rendered off-centre).

   Both show products, collections, pages and blog articles.
   Config comes from window.MEDICUS_SEARCH_AC. */
(function () {
  if (window.__medicusSearchAC) return;
  window.__medicusSearchAC = true;

  var CONFIG = window.MEDICUS_SEARCH_AC || {};
  var SEARCH_URL = CONFIG.searchUrl || '/search';
  var SUGGEST_URL = CONFIG.suggestUrl || '/search/suggest';
  var SYMBOL = CONFIG.symbol || '';
  var POPULAR = CONFIG.popular || [];
  var PLACEHOLDER = CONFIG.placeholder || 'Search caps, guides and blog';
  var MIN_CHARS = 2;
  var DEBOUNCE = 180;
  var MOBILE_QUERY = '(max-width: 749px)';

  var cache = new Map();

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function money(value) {
    if (value === null || value === undefined || value === '') return '';
    return SYMBOL + value;
  }

  function esc(value) {
    var d = document.createElement('div');
    d.textContent = value === null || value === undefined ? '' : String(value);
    return d.innerHTML;
  }

  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function allResultsHref(term) {
    return SEARCH_URL + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
  }

  function listBlock(kindLabel, rows) {
    if (!rows.length) return '';
    var html = '<ul class="msac__list">';
    rows.forEach(function (row) {
      html += '<li><a class="msac__link" data-msac-item href="' + esc(row.url) + '">' +
        '<span class="msac__kind">' + esc(kindLabel) + '</span>' + esc(row.title) + '</a></li>';
    });
    return html + '</ul>';
  }

  function buildHtml(data, term) {
    var results = (data && data.resources && data.resources.results) || {};
    var products = results.products || [];
    var collections = results.collections || [];
    var pages = results.pages || [];
    var articles = results.articles || [];
    var queries = results.queries || [];

    if (!products.length && !collections.length && !pages.length && !articles.length) {
      return '<div class="msac__empty">No matches for <strong>' + esc(term) + '</strong>.' +
        '<span>Try a pattern, a colour, a speciality, or a style such as bouffant, ponytail or tie-back.</span></div>' +
        '<a class="msac__all" data-msac-item href="' + allResultsHref(term) + '">Search the whole store anyway</a>';
    }

    var html = '';

    if (queries.length) {
      html += '<div class="msac__queries">';
      queries.slice(0, 5).forEach(function (q) {
        html += '<a class="msac__query" data-msac-item href="' + esc(q.url) + '">' + esc(q.text) + '</a>';
      });
      html += '</div>';
    }

    var hasSide = collections.length || pages.length || articles.length;
    html += '<div class="msac__cols' + (products.length && hasSide ? ' msac__cols--split' : '') + '">';

    if (products.length) {
      html += '<div class="msac__col msac__col--products"><p class="msac__label">Products</p><ul class="msac__grid">';
      products.forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        html += '<li><a class="msac__product" data-msac-item href="' + esc(p.url) + '">';
        html += img
          ? '<img class="msac__thumb" src="' + esc(thumb(img)) + '" alt="" loading="lazy" width="52" height="52">'
          : '<span class="msac__thumb"></span>';
        html += '<span class="msac__ptext"><span class="msac__ptitle">' + esc(p.title) + '</span>' +
          '<span class="msac__price">' + esc(money(p.price)) + '</span></span></a></li>';
      });
      html += '</ul></div>';
    }

    if (hasSide) {
      html += '<div class="msac__col msac__col--content">';
      html += listBlock('Collection', collections);
      html += listBlock('Guide', pages);
      html += listBlock('Blog', articles);
      html += '</div>';
    }

    html += '</div>';
    html += '<a class="msac__all" data-msac-item href="' + allResultsHref(term) +
      '">See all results for &ldquo;' + esc(term) + '&rdquo;</a>';

    return html;
  }

  function suggestUrlFor(term) {
    return SUGGEST_URL + '.json' +
      '?q=' + encodeURIComponent(term) +
      '&resources%5Btype%5D=product,collection,page,article,query' +
      '&resources%5Blimit%5D=6' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
      '&resources%5Boptions%5D%5Bfields%5D=title,product_type,variants.title,vendor,tag';
  }

  /* Wires one input + one results panel together. */
  function createSearchUI(options) {
    var input = options.input;
    var panel = options.panel;
    var onShow = options.onShow || function () {};
    var onHide = options.onHide || function () {};

    var controller = null;
    var timer = null;
    var items = [];
    var activeIndex = -1;

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');

    function hide() {
      panel.classList.remove('is-visible');
      input.setAttribute('aria-expanded', 'false');
      items = [];
      activeIndex = -1;
      onHide();
    }

    function show(html) {
      panel.innerHTML = html;
      panel.classList.add('is-visible');
      input.setAttribute('aria-expanded', 'true');
      items = Array.prototype.slice.call(panel.querySelectorAll('[data-msac-item]'));
      activeIndex = -1;
      onShow();
    }

    function setActive(next) {
      if (!items.length) return;
      if (activeIndex > -1 && items[activeIndex]) items[activeIndex].classList.remove('is-active');
      activeIndex = next;
      if (activeIndex < 0) activeIndex = items.length - 1;
      if (activeIndex > items.length - 1) activeIndex = 0;
      var el = items[activeIndex];
      el.classList.add('is-active');
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    function fetchResults(term) {
      if (cache.has(term)) {
        show(buildHtml(cache.get(term), term));
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      fetch(suggestUrlFor(term), { signal: controller.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          cache.set(term, data);
          if (input.value.trim() === term) show(buildHtml(data, term));
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          hide();
        });
    }

    function onInput() {
      var term = input.value.trim();
      if (timer) clearTimeout(timer);

      if (term.length < MIN_CHARS) {
        hide();
        return;
      }

      if (!cache.has(term)) {
        panel.innerHTML = '<div class="msac__status">Searching&hellip;</div>';
        panel.classList.add('is-visible');
        onShow();
      }

      timer = setTimeout(function () { fetchResults(term); }, DEBOUNCE);
    }

    input.addEventListener('input', onInput);

    /* Capture phase so this beats the theme's own Enter handler. */
    document.addEventListener('keydown', function (event) {
      if (event.target !== input) return;
      if (!panel.classList.contains('is-visible')) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        event.stopPropagation();
        setActive(activeIndex + 1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        event.stopPropagation();
        setActive(activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex > -1 && items[activeIndex]) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = items[activeIndex].getAttribute('href');
      }
    }, true);

    panel.addEventListener('mousemove', function (event) {
      var item = event.target.closest ? event.target.closest('[data-msac-item]') : null;
      if (!item) return;
      var index = items.indexOf(item);
      if (index > -1 && index !== activeIndex) setActive(index);
    });

    return {
      refresh: onInput,
      hide: hide,
      isOpen: function () { return panel.classList.contains('is-visible'); }
    };
  }

  /* ---------- Desktop: the existing header search bar ---------- */
  function initDesktopBar() {
    var container = document.querySelector('[data-search-mega-menu]');
    if (!container) return;

    var input = container.querySelector('[data-search-input]');
    var dropdown = container.querySelector('[data-search-dropdown]');
    var inner = dropdown ? dropdown.querySelector('.search-mega-menu__dropdown-inner') : null;
    var browse = container.querySelector('.search-mega-menu__browse');
    var menuToggle = container.querySelector('[data-menu-toggle]');
    if (!input || !dropdown || !inner) return;

    var panel = document.createElement('div');
    panel.className = 'msac';
    panel.setAttribute('role', 'region');
    panel.setAttribute('aria-live', 'polite');
    inner.appendChild(panel);

    var ui = createSearchUI({
      input: input,
      panel: panel,
      onShow: function () {
        if (browse) browse.classList.add('msac-hidden');
        dropdown.classList.add('is-open');
        container.classList.add('is-active');
      },
      onHide: function () {
        if (browse) browse.classList.remove('msac-hidden');
      }
    });

    input.addEventListener('focus', function () {
      var term = input.value.trim();
      if (term.length >= MIN_CHARS && cache.has(term)) ui.refresh();
    });

    if (menuToggle) {
      menuToggle.addEventListener('click', function () {
        setTimeout(ui.hide, 0);
      });
    }
  }

  /* ---------- Mobile: full-screen overlay ---------- */
  function initMobileOverlay() {
    var overlay = document.createElement('div');
    overlay.className = 'msac-mobile';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Search');
    overlay.hidden = true;

    var popularHtml = '';
    if (POPULAR.length) {
      popularHtml = '<div class="msac-mobile__popular"><p class="msac__label">Popular searches</p><div class="msac-mobile__chips">';
      POPULAR.forEach(function (item) {
        popularHtml += '<a class="msac__query" href="' + esc(allResultsHref(item.term)) + '">' + esc(item.label) + '</a>';
      });
      popularHtml += '</div></div>';
    }

    overlay.innerHTML =
      '<div class="msac-mobile__bar">' +
        '<form class="msac-mobile__form" action="' + esc(SEARCH_URL) + '" method="get" role="search">' +
          '<svg class="msac-mobile__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>' +
          '<input type="search" name="q" class="msac-mobile__input" placeholder="' + esc(PLACEHOLDER) + '" aria-label="Search" enterkeyhint="search">' +
          '<input type="hidden" name="options[prefix]" value="last">' +
        '</form>' +
        '<button type="button" class="msac-mobile__cancel">Cancel</button>' +
      '</div>' +
      '<div class="msac-mobile__body">' +
        '<div class="msac msac-mobile__results" role="region" aria-live="polite"></div>' +
        popularHtml +
      '</div>';

    document.body.appendChild(overlay);

    var input = overlay.querySelector('.msac-mobile__input');
    var panel = overlay.querySelector('.msac-mobile__results');
    var popular = overlay.querySelector('.msac-mobile__popular');
    var cancel = overlay.querySelector('.msac-mobile__cancel');

    createSearchUI({
      input: input,
      panel: panel,
      onShow: function () { if (popular) popular.hidden = true; },
      onHide: function () { if (popular) popular.hidden = false; }
    });

    function open() {
      overlay.hidden = false;
      document.documentElement.classList.add('msac-locked');
      setTimeout(function () { input.focus(); }, 60);
    }

    function close() {
      overlay.hidden = true;
      document.documentElement.classList.remove('msac-locked');
    }

    cancel.addEventListener('click', close);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !overlay.hidden) close();
    });

    /* Intercept the header magnifier on small screens before the theme
       modal can open. */
    document.addEventListener('click', function (event) {
      if (!isMobile()) return;
      var trigger = event.target.closest ? event.target.closest('search-button') : null;
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      open();
    }, true);

    window.addEventListener('resize', function () {
      if (!isMobile() && !overlay.hidden) close();
    });
  }

  function start() {
    initDesktopBar();
    initMobileOverlay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
